import { render } from "./Offer.vue?vue&type=template&id=316175d1"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"

import "./Offer.vue?vue&type=style&index=0&id=316175d1&lang=css"
script.render = render

export default script